import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import { hasAnyPermission } from '../utils/permissions';
import BlockedAccess from './BlockedAccess';

const PermissionGuard = ({ children, requiredPermission, pageName }) => {
  const { t } = useTranslation();
  const { user } = useAuth();
  
  console.log('PermissionGuard - Checking permission:', requiredPermission);
  console.log('PermissionGuard - User:', user);
  console.log('PermissionGuard - User role:', user?.role);
  console.log('PermissionGuard - User permissions:', user?.permissions);
  
  // SuperAdmin has access to everything
  if (user?.role === 4 || user?.role === 'SuperAdmin') {
    console.log('PermissionGuard - SuperAdmin access granted');
    return children;
  }
  
  // If no user or no permissions array, deny access
  if (!user || !user.permissions || !Array.isArray(user.permissions)) {
    console.log('PermissionGuard - No user or permissions, denying access');
    return (
      <BlockedAccess 
        requiredPermission={requiredPermission}
        pageName={pageName}
      />
    );
  }
  
  // Check if user has the required permission
  const hasPermission = hasAnyPermission(user, [requiredPermission]);
  console.log('PermissionGuard - Has permission:', hasPermission);
  
  if (!hasPermission) {
    console.log('PermissionGuard - Permission denied, showing blocked access');
    return (
      <BlockedAccess 
        requiredPermission={requiredPermission}
        pageName={pageName}
      />
    );
  }
  
  // If user has permission, render the children
  console.log('PermissionGuard - Permission granted, rendering children');
  return children;
};

export default PermissionGuard;
